import { Component, inject } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { Divider } from 'primeng/divider';
import {
  offshoreBunkerFormEvents,
  OffshoreBunkerFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { DynamicFormComponent } from '../shared/dynamic-form/dynamic-form.component';
import { FuelOilBunkerTableComponent } from './sections/fuel-oil-bunker-table/fuel-oil-bunker-table.component';

@Component({
  selector: 're-offshore-bunker',
  templateUrl: './offshore-bunker.component.html',

  imports: [FuelOilBunkerTableComponent, DynamicFormComponent, Divider],
})
export class OffshoreBunkerComponent {
  events = injectDispatch(offshoreBunkerFormEvents);
  offshoreReportStore = inject(OffshoreReportStore);
  offshoreBunkerStore = inject(OffshoreBunkerFormStore);
}
